import reactHotToast, { type ToastOptions } from 'react-hot-toast'

/**
 * App toast types. Use the `icon` option when calling toast() to control
 * which style (error/success/warning/info) your CustomToastMessage uses.
 */
export type ToastType = 'error' | 'success' | 'warning' | 'info'

/** Toast options with icon restricted to ToastType for use with CustomToastMessage. */
export type TypedToastOptions = Omit<ToastOptions, 'icon'> & { icon?: ToastType }

type Message = Parameters<typeof reactHotToast>[0]
type ToastHandler = (message: Message, options?: Omit<TypedToastOptions, 'icon'>) => string

function typedToast(message: Message, options?: TypedToastOptions): string {
  return reactHotToast(message, options)
}

typedToast.error = ((message, options) => reactHotToast(message, { ...options, icon: 'error' })) as ToastHandler
typedToast.success = ((message, options) => reactHotToast(message, { ...options, icon: 'success' })) as ToastHandler
typedToast.warning = ((message, options) => reactHotToast(message, { ...options, icon: 'warning' })) as ToastHandler
typedToast.info = ((message, options) => reactHotToast(message, { ...options, icon: 'info' })) as ToastHandler

typedToast.dismiss = reactHotToast.dismiss
typedToast.dismissAll = reactHotToast.dismissAll
typedToast.remove = reactHotToast.remove
typedToast.removeAll = reactHotToast.removeAll
typedToast.promise = reactHotToast.promise
typedToast.custom = reactHotToast.custom

export const toast = typedToast
